import React from 'react'
import { DataGridPro, GridToolbarQuickFilter } from '@mui/x-data-grid-pro'
import { Box, Checkbox, IconButton } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'

function customCheckbox(theme) {
  return {
    '& .MuiCheckbox-root svg': {
      width: 16,
      height: 16,
      backgroundColor: 'transparent',
      border: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
      borderRadius: 2,
    },
    '& .MuiCheckbox-root svg path': {
      display: 'none',
    },
    '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
      backgroundColor: theme.palette.text.link,
      borderColor: theme.palette.text.link,
    },
    '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
      position: 'absolute',
      display: 'table',
      border: `2px solid ${theme.palette.background.paper}`,
      borderTop: 0,
      borderLeft: 0,
      transform: 'rotate(45deg) translate(-50%,-50%)',
      opacity: 1,
      transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
      content: '""',
      top: '50%',
      left: '39%',
      width: 5.71428571,
      height: 9.14285714,
    },
    '& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after': {
      width: 8,
      height: 8,
      backgroundColor: theme.palette.text.link,
      transform: 'none',
      top: '39%',
      border: 0,
    },
  }
}
export const slotProps = (theme: any, context?: any) => ({
  button: {
    sx: {
      borderRadius: 2,
      maxHeight: '100%',
      mt: 2,
      mb: 2,
      '&:hover': { backgroundColor: alpha(theme.palette.text.primary, 0.1) },
      color: theme.palette.text.primary,
      '& .MuiBadge-badge': {
        backgroundColor: theme.palette.text.highlight, // Your custom background color
        color: theme.palette.text.primary, // Change the text color if needed
        fontSize: '14px', // Optional: adjust the font size
        width: '20px', // Adjust the width/height to control the size of the badge
        height: '20px',
      },
      '& .MuiButton-root': {
        '& span:not(.MuiButton-icon)': {
          display: 'none', // Hides button text
        },
        minWidth: '40px', // Ensures button doesn't take too much space
        padding: '4px', // Adjust padding for better alignment
      },
      '& .MuiButton-startIcon + span': {
        display: 'none',
      },
      '& .MuiSvgIcon-root': {
        fontSize: 0,
        height: 25,
        width: 25,
      },
    },
  },
})

export const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  // '&.MuiCheckbox-root': {
  //   padding: '4px', // Reduce padding
  // },
  // '& .MuiSvgIcon-root': {
  //   width: 18,
  //   height: 18,
  //   backgroundColor: 'transparent',
  //   border: `1px solid ${theme.palette.mode === 'light' ? '#d9d9d9' : 'rgb(67, 67, 67)'}`,
  //   borderRadius: 2,
  // },
  // '&.Mui-checked .MuiSvgIcon-root': {
  //   backgroundColor: '#1890ff',
  //   borderColor: '#1890ff',
  // },
  // '&.Mui-checked .MuiSvgIcon-root path': {
  //   display: 'none',
  // },
  // '&.Mui-checked:after': {
  //   content: '""',
  //   position: 'absolute',
  //   width: 5.7,
  //   height: 9.1,
  //   border: '2px solid #fff',
  //   borderTop: 0,
  //   borderLeft: 0,
  //   transform: 'rotate(45deg) translate(-50%, -50%)',
  //   top: '50%',
  //   left: '39%',
  // },
  // '&.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
  //   backgroundColor: '#1890ff',
  // },
  '& .MuiCheckbox-root svg': {
    width: 16,
    height: 16,
    backgroundColor: 'transparent',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
    borderRadius: 2,
  },
  '& .MuiCheckbox-root svg path': {
    display: 'none',
  },
  '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
    backgroundColor: theme.palette.text.link,
    borderColor: theme.palette.text.link,
  },
  '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
    position: 'absolute',
    display: 'table',
    border: `2px solid ${theme.palette.background.paper}`,
    borderTop: 0,
    borderLeft: 0,
    transform: 'rotate(45deg) translate(-50%,-50%)',
    opacity: 1,
    transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
    content: '""',
    top: '50%',
    left: '39%',
    width: 5.71428571,
    height: 9.14285714,
  },
  '& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after': {
    width: 8,
    height: 8,
    backgroundColor: theme.palette.text.link,
    transform: 'none',
    top: '39%',
    border: 0,
  },
}))
export const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  border: 0,
  maxHeight: '100vh',
  maxWidth: '95vw',
  boxShadow: theme.shadows,
  color: alpha(theme.palette.text.primary, 0.85),
  WebkitFontSmoothing: 'auto',
  letterSpacing: 'normal',
  '& .MuiDataGrid-columnsContainer': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    borderRight: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  },
  '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
    borderBottom: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  },
  '& .MuiDataGrid-cell': {
    backgroundColor: alpha(theme.palette.background.paper, 0.65),
    color: alpha(theme.palette.text.primary, 0.65),
  },
  '& .MuiPaginationItem-root': {
    borderRadius: 0,
  },
  ...customCheckbox(theme),
}))
export const dialogStyles = theme => ({
  width: '100%',
  maxWidth: '800px',
  // backgroundColor: theme.palette.mode === 'dark' ? '' : 'rgb(236, 239, 248)',
  color: theme.palette.text.primary,
  minHeight: '50vh',
  maxHeight: '95vh',
  padding: '30px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '30px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.background.paper,
    minWidth: '100%', // Ensure the input base width fits within the dialog
  },
  '& .MuiFormControl-root': {
    width: '100%', // Ensure the form control takes full width
  },
  '& .MuiDateRangePicker-root': {
    width: '100%', // Ensure the DateRangePicker takes full width
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(theme.palette.text.primary, 0.5),
    borderRadius: '6px',
  },
})
export const gridContainerStyles = {
  display: 'flex',
  maxWidth: '100vw',
  maxHeight: '100vh',
  // width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}
export const userImageStyles = {
  width: '50px', // Set a fixed width
  height: '50px', // Set a fixed height
  borderRadius: '50%', // Make the image circular
  objectFit: 'cover', // Ensure the image covers the box while maintaining aspect ratio
}
export const gridToolbarContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}
export const deleteButtonStyles = theme => ({
  borderColor: 'black',
  color: 'red',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: 'rgba(201, 50, 46)',
    borderColor: 'black',
    color: theme.palette.text.primary,
  },
})
export const getDensityStyles = density => {
  switch (density) {
    case 'compact':
      return {
        chipWidth: 70,
        chipHeight: 25,
        verticalSize: 'small',
        verticalWidth: 120,
        verticalHeight: 25,
        globeSize: 25,
        avatarSize: 26,
        iconSize: 16,
        avatarSpacing: 'medium',
        avatarMax: 4,
        padding: '0px',
        fontSize: 12,
        height: 30,
        width: 30,
        svgSize: 28,
        gap: 1,
      }
    case 'comfortable':
      return {
        chipWidth: 70,
        chipHeight: 30,
        verticalSize: 'large',
        verticalWidth: 220,
        verticalHeight: 45,
        globeSize: 36,
        avatarSize: 52,
        iconSize: 38,
        avatarSpacing: 'small',
        avatarMax: 2,
        padding: '0px',
        fontSize: 15,
        height: 68,
        width: 68,
        svgSize: 58,
        gap: 3,
      }
    case 'standard':
    default:
      return {
        chipWidth: 70,
        chipHeight: 30,
        verticalSize: 'medium',
        verticalWidth: 120,
        verticalHeight: 35,
        globeSize: 32,
        avatarSize: 36,
        iconSize: 20,
        avatarSpacing: 'small',
        avatarMax: 3,
        padding: '0px',
        fontSize: 13,
        height: 48,
        width: 48,
        svgSize: 40,
        gap: 2,
      }
  }
}
// Define a styled component for the black and white effect
export const DisabledIconButton = styled(IconButton)(({ theme }) => ({
  filter: 'grayscale(100%)',
  pointerEvents: 'none',
  opacity: '10%',
}))

// export const StyledGridToolbarQuickFilter = styled(GridToolbarQuickFilter)(({ theme }) => ({
//   '& .MuiInputBase-input': {
//     padding: 5,
//     position: 'relative',
//     '&:focus': {
//       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
//       transition: 'background-color 1s ease-out', // Smooth fade-out transition
//     },
//     '&:focus-visible': {
//       animation: 'fadeOut 2s ease-out forwards', // Trigger animation on focus
//     },
//   },
//   '@keyframes fadeOut': {
//     '0%': {
//       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
//     },
//     '100%': {
//       backgroundColor: 'transparent', // End with the original background
//     },
//   },
// }))
export const StyledGridToolbarQuickFilter = styled(GridToolbarQuickFilter)<{
  placeholder?: string
  inputRef?: React.RefObject<any>
}>(({ theme }) => ({
  '&.MuiFormControl-root': {
    // This applies the styles to the root element of the quick filter
    // backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    border: '1px solid',
    borderColor: 'transparent',
    padding: '5px',
    // borderRadius: '4px',
    transition: 'border-color 0.5s ease',

    // Add a subtle focus effect
    '&:focus-within': {
      border: '1px solid',
      borderColor: alpha(theme.palette.text.primary, 0.3),
    },
  },
  '@keyframes fadeOut': {
    '0%': {
      border: '1px solid',
      borderColor: alpha(theme.palette.text.primary, 0.4),
    },
    '100%': {
      borderColor: 'transparent',
    },
  },
  '& .MuiInputBase-root': {
    paddingLeft: '8px', // Adjust padding or any other desired style here
  },
}))
export const fieldStyles = fieldBgColor => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: fieldBgColor,
  '& .MuiOutlinedInput-root': {
    backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiInputBase-root': {
    backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiInputBase-input': {
    // backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiOutlinedInput-notchedOutline': {
    // borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    // borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    // borderColor: 'transparent', // Keeps the outline invisible on hover
  },
})

export const RenderCellBox = styled(Box)<{ densityStyles?: any }>(({ densityStyles }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  padding: densityStyles?.padding,
  gap: densityStyles?.gap,
}))
export const popoverStyles = theme => ({
  backgroundColor: alpha(theme.palette.background.paper, 0.85),
  zIndex: 1500,
})

export const boxContainerStyles = theme => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(2),
})
export const textStyles = theme => ({
  width: '100%',
  color: theme.palette.text.primary,
  padding: theme.spacing(1),
  fontSize: 18,
})
export const boxStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  width: '100%',
  border: '1px solid',
  borderColor: 'rgba(201, 50, 46, 0.5)',
  padding: theme.spacing(1),
})
export const buttonContainerStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginTop: theme.spacing(2),
  gap: theme.spacing(1),
})
export const subtaskStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  border: '1px solid',
  p: 1,
  borderColor: theme.palette.text.warning,
})
